export const NOTIFY = 'NOTIFY';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';